export class Constant {


    public static IdleTimeout = 600000;
    public static FinalInactivityTimeOut = 120000;
    public static Entrykey = 'EntryKey';
    public static BaseAPIURL = 'api/v1/';
    public static ErrorMessageCookieName = 'ATITesting_ErrorMessage';
    public static InternalActionCookieName = 'ATITesting_InternalAction';
    public static SelectedTutorialName =  'SelectedTutorialName';

    public static SelectedModuleName = 'SelectedModuleName';
    public static XSRFTOKENCookieName = 'XSRF-TOKEN';
    public static LearningActivityTypeKognito = 27;
    public static LearningActivityTypeEHRTutor = 32;
    public static LearningActivityTypeStaticContent = 33;
    public static LearningActivityTypeHealthAssess = 34;
    public static LearningActivityTypeSkills = 37;
    public static LearningActivityTypeFundamentals = 38;
    public static LearningActivityTypeEHRTReadOnlyChart = 40;
    public static OriginUrlPattern = '*';
    
}

export class UBTConstants{
    public static UBTEnabled = true;
    public static Environment = 'qa';
    public static AuthenticatedUserCookieUserID = 'AuthenticatedUserCookieUserID';
    public static XSRFToken = 'XSRF-TOKEN';    

    public static tpSourceSystem = 'ATI';
    public static applicationId = 1;
    public static oAuthApplicationId=  1;
    public static statementVersion=  1.03;
    public static locationType=  'WEB_PAGE';

    public static appName = 'StaticContent';
    public static locationTypeMobile = 'Mobile';

        // VerbType
        public static VerbTypeFlipped = 'flipped';
        public static VerbTypeAnswered = 'answered';
        public static VerbTypeSelected = 'selected';
        public static VerbTypeSubmitted = 'submitted';
        public static VerbTypeClosed = 'closed';
        public static VerbTypeExited = 'exited';
        public static VerbTypeRepeated = 'repeated';
        public static VerbTypeLaunched = 'launched';
        public static VerbTypeInteracted = 'interacted';
        public static VerbTypePlayed = 'played';
        public static VerbTypePaused = 'paused';
        public static VerbTypeCompleted = 'completed';
        public static VerbTypeScrolled = 'scrolled';
        public static VerbTypeProgressed = 'progressed';
    
        //Activity
        public static ActivityNameFlashcard = "flashcard";
        public static ActivityNameRemediation = "remediation";
        public static ActivityNameAnswer = "answer";
        public static ActivityNameDrillQuestionAnswer = "drillquestionanswer";
        public static ActivityNameModule = "module";
        public static ActivityNameLesson=  "lesson";
        public static ActivityNamePage=  "page";
        public static ActivityNameGame = "game";
        public static ActivityNameSelfCheck = "selfcheck";
        public static ActivityNameDrill = "drill";
        public static ActivityNameAudio = "audio";
        public static ActivityNameVideo = "video";
        public static ActivityNameViewMore = "viewmore";
        public static ActivityNameQuestion = "question";
        public static ActivityNameMenu = "menu";
}
